export default {
  INFO: 0,
  ERROR: 1,
  WARNING: 2,
}
